<template>
  <div
    class="play-media"
    :class="[`play-media--${verticalAlign}`, { 'play-media--reverse': right }]"
  >
    <div
      v-if="$slots.aside"
      class="play-media__aside"
    >
      <slot name="aside" />
    </div>
    <div class="play-media__body">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * PlayMedia — media object (figure + body) for the Play system.
 *
 * Token-driven (see src/styles/tokens.scss). Replaces bootstrap-vue's <b-media>
 * + <b-media-aside> with one component: the `aside` slot is the leading figure
 * (avatar/icon/image), the default slot is the body. `verticalAlign` lines them
 * up (top/center/bottom); `right` flips the aside to the trailing side.
 *
 * VUE3-MIGRATION: nothing Vue 2-specific — already Vue 3-safe.
 */
export default {
  name: 'PlayMedia',
  props: {
    verticalAlign: {
      type: String,
      default: 'top',
      validator: v => ['top', 'center', 'bottom'].includes(v),
    },
    /** Place the aside on the trailing side */
    right: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.play-media {
  display: flex;
  gap: 14px;

  &--reverse { flex-direction: row-reverse; }

  &--top    { align-items: flex-start; }
  &--center { align-items: center; }
  &--bottom { align-items: flex-end; }

  &__aside {
    flex-shrink: 0;
    display: flex;
  }

  &__body {
    flex: 1 1 auto;
    min-width: 0;
  }
}
</style>
